export default __webpack_public_path__ + "static/2187-d2d1c4b8f4d92c785ce7dbc62ba5a870.gif";